module.exports = __webpack_public_path__ + "img/06_1_4_2.1493fdb3.png";